import { ReactNode } from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';

import { ScenarioType } from '../../../../../../types/scenario-modeling.types';
import { FundraisingFormSchema } from '../../../fundraising-validation';

export const itemsToFetchMap = [5, 10, 20, 50, 100];

export type ExistingItemListProps = {
  additionalColumns: (ReactNode | string)[];
  additionalColumnsCount: number;
  columns: (ReactNode | string)[];
  columnsCount: number;
  companyId: string;
  control: Control<FundraisingFormSchema>;
  scenarioId: string;
  scenarioType: ScenarioType;
  setValue: UseFormSetValue<FundraisingFormSchema>;
};

export type NewItemListProps = {
  addButtonText: ReactNode | string;
  columns: (ReactNode | string)[];
  columnsCount: number;
  companyId: string;
  control: Control<FundraisingFormSchema>;
  scenarioId: string;
};
